var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#profile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M0 0h88v88H0z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#profile_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M0 0h88v88H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 37.401,
    r: 15.84,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.294 58.084c18.197.182 32.851 8.778 32.851 19.356 1.556 29.966-1.918 36.021-33.146 30.115-31.227 5.906-34.7-.149-33.146-30.115 0-10.578 14.655-19.174 32.852-19.356v-.004l.294.002.295-.002z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "profile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h88v88H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "profile_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h88v88H0z"
  })))));
};
export default SvgProfile;